import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "gx-dialog-header" };
const _hoisted_2 = { class: "gx-dialog-title" };
const _hoisted_3 = { class: "title-text" };
const _hoisted_4 = { class: "title-actions" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Close = _resolveComponent("Close");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_dialog = _resolveComponent("el-dialog");
    return (_openBlock(), _createBlock(_component_el_dialog, _mergeProps({
        "model-value": _ctx.modelValue,
        "onUpdate:modelValue": _ctx.handleUpdateModelValue,
        "show-close": false,
        class: _ctx.dialogClassNames
    }, _ctx.dialogAttrs, { onClose: _ctx.handleClose }), {
        header: _withCtx(() => [
            _createElementVNode("header", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("section", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "header-actions", {}, undefined, true)
                    ])
                ]),
                (_ctx.showClose)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "custom-close-button",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.handleCloseButtonClick && _ctx.handleCloseButtonClick(...args))),
                        "aria-label": "关闭"
                    }, [
                        _createVNode(_component_el_icon, { class: "close-icon" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_Close)
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        footer: _withCtx(() => [
            _createElementVNode("div", {
                class: _normalizeClass({ 'gx-dialog-footer': _ctx.hasFooterContent })
            }, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
            ], 2)
        ]),
        default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-divider" }, null, -1)),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
    }, 16, ["model-value", "onUpdate:modelValue", "class", "onClose"]));
}
